import React from 'react';
import { Input } from 'antd';
import { Flex } from 'antd-v5';
import { PlusOutlined } from '@ant-design/icons';
import OnTraccrButton from './buttons/OnTraccrButton';

export default function SideListSearchHeader({
  onClick,
  onChange,
  submissionView,
  filterView,
}) {
  return (
    <Flex
      vertical
      justify="center"
      align="center"
      gap={8}
      style={{
        height: '100%',
        width: '100%',
        padding: 10,
      }}
    >
      <Flex style={{ width: '100%' }}>
        <Input.Search
          className="searchbar"
          placeholder="Search"
          onChange={onChange}
          allowClear
          style={{ width: '100%' }}
        />
      </Flex>
      {submissionView && (
        <Flex style={{ width: '100%' }} align="center">
          {submissionView}
        </Flex>
      )}
      {(filterView || onClick) && (
        <Flex style={{ width: '100%' }} align="center" justify="center" gap={8}>
          {filterView}
          {onClick && (
            <OnTraccrButton title="Add" icon={<PlusOutlined />} onClick={onClick} />
          )}
        </Flex>
      )}
    </Flex>
  );
}
